import React from 'react';
import { useLocation } from 'react-router-dom';
import { getSearchParams } from '../../../../commons/models/params';
import { useGetAnnoncesVigueurQuery } from '../../../../redux/api/cache';

export default function GridProduct(props) {
  const location = useLocation();

  const { data: product } = useGetAnnoncesVigueurQuery({ ann_seq: getSearchParams('Produit', location.pathname) });

  const { data: inventory } = useGetAnnoncesVigueurQuery({ ann_seq: getSearchParams('Inventaire', location.pathname) });

  const { data: Vnl } = useGetAnnoncesVigueurQuery({ ann_seq: getSearchParams('', location.pathname) });

  return (
    <p>
      Produit: {JSON.stringify(inventory)}
      <br></br>
      Inventaire: {JSON.stringify(product)}
      <br></br>
      Fenetre spécifique: {JSON.stringify(Vnl)}
    </p>
  );
}
